// // import PropTypes from "prop-types"
// // import { Switch, BrowserRouter as Router } from "react-router-dom"
// // import { connect } from "react-redux"
// // // Import Routes all
// // import { authProtectedRoutes, publicRoutes } from "./routes"
// // // Import all middleware
// // import Authmiddleware from "./routes/route"
// // // layouts Format
// // import VerticalLayout from "./components/VerticalLayout/"
// // import HorizontalLayout from "./components/HorizontalLayout/"
// // import NonAuthLayout from "./components/NonAuthLayout"
// // // Import scss
// // import "./assets/scss/theme.scss"
// // import fakeBackend from "./helpers/AuthType/fakeBackend"
// // import React, {useEffect, useState} from "react"
// // // import { useIdleTimer } from "react-idle-timer"
// // // Activating fake backend
// // fakeBackend()
// //
// // const App = props => {
// //   var lng = localStorage.getItem("I18N_LANGUAGE")
// //   // const handleOnIdle = event => {
// //   //   if (event === undefined) {
// //   //     localStorage.clear()
// //   //   }
// //   // }
// //   // const handleOnActive = event => {}
// //   // const handleOnAction = event => {}
// //   // const { getRemainingTime, getLastActiveTime } = useIdleTimer({
// //   //   timeout: 100 * 30 * 10,
// //   //   onIdle: handleOnIdle,
// //   //   onActive: handleOnActive,
// //   //   onAction: handleOnAction,
// //   //   debounce: 500,
// //   // })
// //   useEffect(() => {
// //     const handleContextMenu = (e) => {
// //       e.preventDefault();
// //     };
// //     window.addEventListener('contextmenu', function(e) {
// //       e.preventDefault();
// //     });
// //     document.addEventListener('contextmenu', handleContextMenu);
// //     const handleKeyDown = (event) => {
// //       if (event.key === 'F12') {
// //         event.preventDefault();
// //         // alert('L\'inspection du navigateur n\'est pas autorisée.');
// //       }
// //     };
// //     window.addEventListener('keydown', handleKeyDown);
// //     return () => {
// //       window.removeEventListener('keydown', handleKeyDown);
// //     };
// //   }, []);
// //   function getLayout() {
// //     let layoutCls = VerticalLayout
// //     switch (props.layout.layoutType) {
// //       case "horizontal":
// //         layoutCls = HorizontalLayout
// //         break
// //       default:
// //         layoutCls = VerticalLayout
// //         break
// //     }
// //     return layoutCls
// //   }
// //
// //   const Layout = getLayout()
// //   return (
// //     <div>
// //       <React.Fragment>
// //         <Router>
// //           <Switch>
// //             {publicRoutes.map((route, idx) => (
// //               <Authmiddleware
// //                 path={route.path}
// //                 layout={NonAuthLayout}
// //                 component={route.component}
// //                 key={idx}
// //                 isAuthProtected={false}
// //                 exact
// //               />
// //             ))}
// //
// //             {lng == "ar"
// //               ? authProtectedRoutes.map((route, idx) => (
// //                   <Authmiddleware
// //                     path={route.path}
// //                     layout={Layout}
// //                     component={route.component}
// //                     key={idx}
// //                     isAuthProtected={true}
// //                     exact
// //                   />
// //                 ))
// //               : authProtectedRoutes.map((route, idx) => (
// //                   <Authmiddleware
// //                     path={route.path}
// //                     layout={Layout}
// //                     component={route.component}
// //                     key={idx}
// //                     isAuthProtected={true}
// //                     exact
// //                   />
// //                 ))}
// //           </Switch>
// //         </Router>
// //       </React.Fragment>
// //     </div>
// //   )
// // }
// //
// // App.propTypes = {
// //   layout: PropTypes.any,
// // }
// //
// // const mapStateToProps = state => {
// //   return {
// //     layout: state.Layout,
// //   }
// // }
// //
// // export default connect(mapStateToProps, null)(App)
// import PropTypes from "prop-types";
// import { Switch, BrowserRouter as Router } from "react-router-dom";
// import { connect } from "react-redux";
// import React, { useEffect } from "react";
//
// import {  publicRoutes, masterOpenRoutes } from "./routes";
//
// import Authmiddleware from "./routes/route";
//
// import VerticalLayout from "./components/VerticalLayout/";
// import HorizontalLayout from "./components/HorizontalLayout/";
// import NonAuthLayout from "./components/NonAuthLayout";
//
// import "./assets/scss/theme.scss";
// import fakeBackend from "./helpers/AuthType/fakeBackend";
// import MasterOpenMiddleware from "./routes/MasterOpenMiddleware"
//
// fakeBackend();
//
// const App = props => {
//   var lng = localStorage.getItem("I18N_LANGUAGE");
//
//   useEffect(() => {
//     const handleContextMenu = e => e.preventDefault();
//     document.addEventListener("contextmenu", handleContextMenu);
//
//     const handleKeyDown = event => {
//       if (event.key === "F12") event.preventDefault();
//     };
//     window.addEventListener("keydown", handleKeyDown);
//
//     return () => {
//       document.removeEventListener("contextmenu", handleContextMenu);
//       window.removeEventListener("keydown", handleKeyDown);
//     };
//   }, []);
//
//   function getLayout() {
//     switch (props.layout.layoutType) {
//       case "horizontal":
//         return HorizontalLayout;
//       default:
//         return VerticalLayout;
//     }
//   }
//
//   const Layout = getLayout();
//
//   return (
//     <Router>
//       <Switch>
//         {/* Routes publiques */}
//         {publicRoutes.map((route, idx) => (
//           <Authmiddleware
//             key={idx}
//             path={route.path}
//             layout={NonAuthLayout}
//             component={route.component}
//             isAuthProtected={false}
//             exact
//           />
//         ))}
//
//         {/* Routes ouvertes seulement si master ouvert */}
//         {masterOpenRoutes.map((route, idx) => (
//           <MasterOpenMiddleware
//             key={idx}
//             path={route.path}
//             layout={NonAuthLayout}
//             component={route.component}
//             exact
//           />
//         ))}
//
//
//       </Switch>
//     </Router>
//   );
// };
//
// App.propTypes = {
//   layout: PropTypes.any,
// };
//
// const mapStateToProps = state => ({
//   layout: state.Layout,
// });
//
// export default connect(mapStateToProps)(App);
import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { Switch, BrowserRouter as Router, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import { publicRoutes, masterOpenRoutes } from "./routes";
import Authmiddleware from "./routes/route";
import MasterOpenMiddleware from "./routes/MasterOpenMiddleware";

import VerticalLayout from "./components/VerticalLayout/";
import HorizontalLayout from "./components/HorizontalLayout/";
import NonAuthLayout from "./components/NonAuthLayout";

import { MasterProvider } from "./routes/MasterContext";

import "./assets/scss/theme.scss";
import fakeBackend from "./helpers/AuthType/fakeBackend";

fakeBackend();

const App = props => {
  useEffect(() => {
    const disableContextMenu = e => e.preventDefault();
    document.addEventListener("contextmenu", disableContextMenu);
    return () =>
      document.removeEventListener("contextmenu", disableContextMenu);
  }, []);

  const getLayout = () => {
    return props.layout.layoutType === "horizontal"
      ? HorizontalLayout
      : VerticalLayout;
  };

  const Layout = getLayout();

  return (
    <MasterProvider>
      <Router>
        <Switch>

          {/* ✅ Route par défaut */}
          <Redirect exact from="/" to="/Redirection" />

          {/* Routes publiques */}
          {publicRoutes.map((route, idx) => (
            <Authmiddleware
              key={idx}
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              isAuthProtected={false}
              exact
            />
          ))}

          {/* Routes ouvertes seulement si master ouvert */}
          {masterOpenRoutes.map((route, idx) => (
            <MasterOpenMiddleware
              key={idx}
              path={route.path}
              layout={NonAuthLayout}
              component={route.component}
              exact
            />
          ))}

          {/* Fallback sécurité */}
          <Redirect to="/Redirection" />

        </Switch>
      </Router>
    </MasterProvider>
  );
};

App.propTypes = {
  layout: PropTypes.any,
};

const mapStateToProps = state => ({
  layout: state.Layout,
});

export default connect(mapStateToProps)(App);
